import { FC, HTMLProps } from 'react';

export const EyeIcon: FC<HTMLProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      {...props}
    >
      <path
        d="M12.4983 10.579C12.4983 11.9597 11.379 13.079 9.99833 13.079C8.61762 13.079 7.49833 11.9597 7.49833 10.579C7.49833 9.19829 8.61762 8.079 9.99833 8.079C11.379 8.079 12.4983 9.19829 12.4983 10.579Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.04688 10.579C3.10877 7.19806 6.26734 4.74567 9.9987 4.74567C13.7301 4.74567 16.8887 7.1981 17.9505 10.579C16.8886 13.9599 13.7301 16.4123 9.99872 16.4123C6.26734 16.4123 3.10875 13.9599 2.04688 10.579Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
